import React, { useEffect, useState, useLayoutEffect } from "react";
import Head from "next/head";
import axios from "axios";
import { useRouter } from "next/router";
import { useDispatch, useSelector } from "react-redux";
import "react-multi-carousel/lib/styles.css";
import Carousel from "react-multi-carousel";
import AWS from "aws-sdk";
import ErrorBanner from "./ErrorPage/ErrorBanner";
import { Constants } from "../helpers/constants";
import PageTitle from "./PageTitle";
import BookmarkMenu from "./brandmenu.js/bookmarkMenu";
import BrandBanner from "./brand-banner/brand-banner";
import BrandSlider from "./brand-slider/brandslider";
// import Exterior360 from "./exterior-360";
// import Interior360 from "./interior-360";
import BrandCard from "./brandcard/brand-card";
import CompareBoard from "./compare/compareboard";
import TopicSlider from "./topics/topicSlider";
import ExperienceIcon from "./experience-icon";
import TestimonialSliderContainer from "./testimonial/TestimonialSliderContainer";
import HomeSuzukiCard from "./find-suzuki/homeSuzukiCard";
import useIsMobile from "../hooks/useIsMobile";
import { configuration } from "../helpers/config";
import { formNames } from "./forms/Validation";
import { toggleForm } from "../redux/ActionCreator";
import styles from "../styles/faq.module.css";
import Accordion from "./accordion";
import dynamic from "next/dynamic";

const Exterior360 = dynamic(() => import("./exterior-360"), {
  ssr: false,
  loading: () => <p>loading</p>,
});
const Interior360 = dynamic(() => import("./interior-360"), {
  ssr: false,
  loading: () => <p>loading</p>,
});

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
  },
  tablet: {
    breakpoint: { max: 1024, min: 640 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 640, min: 0 },
    items: 1,
    partialVisibilityGutter: 60,
  },
};

export async function getServerSideProps(context) {
  const { req } = context;
  const currentUrl = `${req.headers.host}`;
  const apiData = await axios.get(
    `${configuration.APP_URL_CONTENTS}/dealer-code?url=${currentUrl}`,
  );
  const lobData = apiData?.data?.result?.[0] || "" ;
  
  const { brand } = context.params;
  try {
    const res = await axios.get(
      `${configuration.APP_URL_PRODUCTS}model/${brand}`
    );
    const { data } = res;
    let configuratorData = "";
    if (data?.data) {
      configuratorData = await axios.get(
        `${configuration.APP_URL_PRODUCTS}configurator/${data?.data?.model_code}`
      );
    }

    const cars = await axios.get(`${configuration.APP_URL_PRODUCTS}model/`);
    // const cmsResponse = await axios.get(
    //   `${configuration.APP_URL_CONTENTS}/cms-pages`,
    // );
    let allCarsData = cars.data.data;
    // let allCmsData = cmsResponse.data;
    let tempID = [];
    await Promise.all(
      data?.data?.car_topic?.map(async (e) => {
        tempID.push(e.car_id);
      })
    );

    let allCmsData = [];
    if (tempID.length > 0) {
      const res = await axios.post(
        `${configuration.APP_URL_CONTENTS}/cms-pages`,
        tempID,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      allCmsData = res?.data;
    }

    const topicsData = data?.data?.car_topic
      ? data?.data?.car_topic
          ?.filter((product) => {
            return allCmsData.some((other) => other._id === product.car_id);
          })
          .map((product) => {
            const { car_id, status } = product;
            const other = allCmsData.find((other) => other._id === car_id);
            return { car_id, status, ...other };
          })
      : [];
          
    const linkedData = data?.data?.car_product
      ? data?.data?.car_product
          ?.filter((product) => {
            return allCarsData.some((other) => other._id === product.car_id);
          })
          .map((product) => {
            const { car_id, status } = product;
            const other = allCarsData.find((other) => other._id === car_id);
            return { car_id, status, ...other };
          })
      : [];
    if (data.data) {
      return {
        props: {
          data: {
            ...data.data,
            car_product: linkedData,
            car_topic: topicsData,
            configuratorData: configuratorData?.data?.data || {},
          },
        },
      };
    } else {
      return {
        props: {
          error: true,
        },
      };
    }
  } catch (err) {
    // console.warn(err, "Error Fetching Brand Page Data");
    return {
      props: {
        error: true,
      },
    };
  }
}

export default function BrandPage(props) {
  const dispatch = useDispatch();
  const router = useRouter();
  const mobile = useIsMobile();
  const brand = router.query.brand;
  const [bannerPrice, setBannerPrice] = useState(0);
  const [recentModelData, setRecentModelData] = useState();
  const currentDate = new Date().toISOString();
  const [themeData, setThemeData] = useState(null);
  const [bannerfirstPrice, setbannerfirstPrice] = useState(0);
  const [bannersecondPrice, setbannersecondPrice] = useState(0);
  const [bannerthirdPrice, setbannerthirdPrice] = useState(0);
  const [colorsArr, setColorsArr] = useState();
  const [s3ImagesExterior, setS3ImagesExterior] = useState(null);

  const [s3ImagesInterior, setS3ImagesInterior] = useState(null);

  const [exteriorImgArrLength, setExteriorImgArrLength] = useState(0);

  const [interiorImgArrLength, setInteriorImgArrLength] = useState(0);

  const [s3ImagesExterior2, setS3ImagesExterior2] = useState(null);
  const [isPriceLoaded, setIsPriceLoaded] = useState(false);

  const LobValue = useSelector((state) => state?.app?.LobValue);

   const interiorImageSrc = `${configuration.IMG_URL}${
    props?.data?.configuratorData &&
    Object.keys(props?.data?.configuratorData).length > 0
      ? props?.data?.configuratorData?.variants[0]
        ? props?.data?.configuratorData?.variants[0]?.interior
            ?.interior_images[0]?.value
        : ""
      : ""
   }`;

   // Check conditions before using the configuration image URL
  //  let interiorImageSrc='';
  //  if (
  //    props?.data?.configuratorData?.variants?.[0]?.interior?.interior_images?.[0]?.value
  //  ) {
  //    return interiorImageSrc = `${configuration.IMG_URL}${props.data.configuratorData.variants[0].interior.interior_images[0].value}`;
  //  }

  const ROUTE_ADDRESS = LobValue
    ? LobValue == 1
      ? "/find-dealer/4w-vehicle"
      : LobValue == 2
      ? "/find-dealer/2w-vehicle"
      : LobValue == 3
      ? "/find-dealer/marine-vehicle"
      : "/404"
    : "/404";

  const FormName = LobValue
    ? LobValue == 1
      ? formNames.TEST_DRIVE
      : LobValue == 2
      ? formNames.TEST_DRIVE_2W
      : LobValue == 3
      ? formNames.TEST_DRIVE
      : "/404"
    : "/404";

  const brochure = LobValue
    ? LobValue == 1
      ? formNames.BROCHURE
      : LobValue == 2
      ? formNames.BROCHURE_2W
      : LobValue == 3
      ? formNames.BROCHURE
      : "/404"
    : "/404";

    const Get_a_Quote = LobValue
     ? LobValue == 1
       ? formNames.GET_QUOTE
       : LobValue == 2
       ? formNames.GET_QUOTE_2W
       : LobValue == 3
       ? formNames.GET_QUOTE
       : "/404"
	     : "/404";
  useEffect(() => {
    //  handleRecentModelUpdate();
    (async () => {
      if (!LobValue) return; 
      const res = await axios.get(
        `${configuration.COMMON_MASTER_API}/sellingPrices?modelCode=${props?.data?.model_code}&startDate=${currentDate}&endDate=${currentDate}&dealerCode=${configuration.DEALER_CODE}&lob=${LobValue}`,
        configuration.HEADER_DEALER_LOCATOR
      );

      //new code starts
      let firstPrice = Number(
        res?.data?.data[0]?.sellingPriceDetails[0]?.[
          props?.data?.car_page_price_one
        ]
      );
      
      let secondPrice = Number(
        res?.data?.data[0]?.sellingPriceDetails[0]?.[
          props?.data?.car_page_price_two
        ]
      );
      let thirdPrice = Number(
        res?.data?.data[0]?.sellingPriceDetails[0]?.[
          props?.data?.car_page_price_three
        ]
      );
      for (let [idx, data] of res.data?.data.entries()) {
        if (res?.data?.data[idx]?.sellingPriceDetails.length) {
          for (let [index, sellingPrice] of res?.data?.data[
            idx
          ]?.sellingPriceDetails.entries()) {
            firstPrice = Math.min(
              firstPrice,
              Number(sellingPrice[props?.data?.car_page_price_one])
            );
            secondPrice = Math.min(
              secondPrice,
              Number(sellingPrice[props?.data?.car_page_price_two])
            );
            thirdPrice = Math.min(
              thirdPrice,
              Number(sellingPrice[props?.data?.car_page_price_three])
            );
          }

          setbannerfirstPrice(configuration?.COUNTRY_CODE=="PH" && props?.data?.model_code=="DZ"?Number(920000):firstPrice);
          setbannersecondPrice(secondPrice);
          setbannerthirdPrice(thirdPrice);
          setIsPriceLoaded(true);
          // sethomepagefirstPrice(res?.data?.data[0]?.sellingPriceDetails[0]?.[car_page_price_one])
          // sethomepagesecondPrice(res?.data?.data[0]?.sellingPriceDetails[0]?.[car_page_price_two])
          // sethomepagethirdPrice(res?.data?.data[0]?.sellingPriceDetails[0]?.[car_page_price_three])
        }
      }
    })();
  }, [props?.data?.model_code, LobValue]);

  useEffect(() => {
    if(!LobValue) return ;
    getThemeData();
  }, [LobValue]);

  //fetch s3 images for exterior

  useEffect(() => {
    if (props?.data?.model_code) {
      // Initialize AWS S3 client with credentials and region

      const s3 = new AWS.S3({
        accessKeyId: process.env.NEXT_PUBLIC_AWS_ACCESS_KEY_ID,

        secretAccessKey: process.env.NEXT_PUBLIC_AWS_SECRET_ACCESS_KEY,

        region: process.env.NEXT_PUBLIC_AWS_REGION,
      });

      // Define parameters for getting an object from the S3 bucket

      const params = {
        Bucket: process.env.NEXT_PUBLIC_AWS_BUCKET_NAME,

        Prefix: `models/parallax-images/${props?.data?.model_code}/exterior`, // Specify the folder name here
      };

      // Use the S3 client to get the object (image) from the specified bucket

      s3.listObjectsV2(params, (err, data) => {
        if (err) {
          setS3ImagesExterior(null);
        } else {
          setExteriorImgArrLength(data?.Contents?.length);

          const arr = data?.Contents?.map((x) => {
            return `${configuration.IMG_URL}${x?.Key}`;
          });

          setS3ImagesExterior(arr);
        }
      });
    }
  }, [props?.data?.model_code]);

  //fetch s3 images for interior

  useEffect(() => {
    if (props?.data?.model_code) {
      // Initialize AWS S3 client with credentials and region

      const s3 = new AWS.S3({
        accessKeyId: process.env.NEXT_PUBLIC_AWS_ACCESS_KEY_ID,

        secretAccessKey: process.env.NEXT_PUBLIC_AWS_SECRET_ACCESS_KEY,

        region: process.env.NEXT_PUBLIC_AWS_REGION,
      });

      // Define parameters for getting an object from the S3 bucket

      const params = {
        Bucket: process.env.NEXT_PUBLIC_AWS_BUCKET_NAME,

        Prefix: `models/parallax-images/${props?.data?.model_code}/interior`, // Specify the folder name here
      };

      // Use the S3 client to get the object (image) from the specified bucket

      s3.listObjectsV2(params, (err, data) => {
        if (err) {
          console.log("Error ", err);

          setS3ImagesInterior(null);
        } else {
          setInteriorImgArrLength(data?.Contents?.length);

          const arr = data?.Contents?.map((x) => {
            return `${configuration.IMG_URL}${x?.Key}`;
          });

          setS3ImagesInterior(arr);
        }
      });
    }
  }, [props?.data?.model_code]);

  useEffect(() => {
    getExteriorInteriorData();
  }, [props?.data?.configuratorData]);

  const getExteriorInteriorData = () => {
    if (props?.data?.configuratorData?.variants?.length > 0) {
      let defaultVariant = props?.data?.configuratorData?.variants?.find(
        (x) => x.is_default === true
      );

      let defaultColorArr = [];
      if (defaultVariant) {
        defaultColorArr = defaultVariant?.colors;
      } else {
        defaultColorArr = props?.data?.configuratorData?.variants[0]?.colors;
      }

      const colorArr = [];
      defaultColorArr?.map((x) => {
        let obj = {
          name: "",
          value1: "",
          value2:"",
          exteriorImages: "",
          // extStaticImage:props?.data?.configuratorData?.ExtStaticImageToggle
        };
        obj.name = x.color_name;
        // obj.value = `${configuration.IMG_URL}${x?.exterior_images[3]?.value}`;
        obj.value1 = x?.hex_code;
        obj.value2 = x?.hex_code2;
        obj.exteriorImages = x?.exterior_images?.map((x) => {
          return `${configuration.IMG_URL}${x?.value}`;
        });
        obj.extStaticImage = x?.ExtStaticImageToggle
          ? x?.ExtStaticImageToggle
          : props?.data?.configuratorData?.ExtStaticImageToggle;
        // obj.staticExtImage=x?.static_image_exterior
        obj.staticExtImageDesktop = [
          `${configuration.IMG_URL}${x?.static_image_exterior?.desktop}`,
        ];
        obj.staticExtImageMobile = [
          `${configuration.IMG_URL}${x?.static_image_exterior?.mobile}`,
        ];

        colorArr.push(obj);
      });
      setColorsArr(colorArr);
    }
  };

  const custServices = {
     heads: Constants.faqs.FREQUENTLY_ASKED_QUESTION,
     selectText: Constants.faqs.FURTHER_QUESTIONS,
     openText: Constants.faqs.SHOW_LESS,
  };

  const getThemeData = async () => {
    const { data } = await axios.get(
      `${configuration.APP_URL_CONTENTS}/settings?lob=${LobValue}`
    );
    if (data?.length > 0) {
      setThemeData(data[0]?.theme_settings?.find((x) => x.applied === true));
    }
  };

  if (props.error) {
    return (
      <h1>
        <ErrorBanner
          image={`${configuration.IMG_STATIC_URL}errorBanner.png`}
          imageMob={`${configuration.IMG_STATIC_URL}errorMob.png`}
          error="404"
          desc={Constants.error.DESCRIPTION}
          btn={Constants.error.BUTTON_TEXT}
        />
      </h1>
    );
  }

  return (
    <>
      <Head>
        <meta name="description" content={props?.data?.seo_settings?.desc} />
        <meta name="keywords" content={props?.data?.seo_settings?.keywords} />
        <meta name="keywords" content={props?.data?.seo_settings?.keywords} />
      </Head>
      <PageTitle title={props?.data?.seo_settings?.title} />
      {/* brand bookmark menu */}
      {props?.data?.menu_id && <BookmarkMenu menuId={props?.data?.menu_id}  menudata ={props?.submenudata}/>}

      {/* banner section */}

      <BrandBanner
        videoUrl={props?.data?.image_video}
        mobvideoUrl={props?.data?.mobile_video}
        banners={props?.data?.images}
        retailPrice={bannerPrice}
        modelName={props?.data?.model_name}
        mileage={props?.data?.mileage}
        vehicleType={props?.data?.fuel_type}
        themeSetting={themeData}
        bannerfirstPrice={bannerfirstPrice}
        bannersecondPrice={bannersecondPrice}
        bannerthirdPrice={bannerthirdPrice}
        bannerfirstPriceText={props?.data?.car_page_pricetext_one}
        bannersecondPriceText={props?.data?.car_page_pricetext_two}
        bannerthirdPriceText={props?.data?.car_page_pricetext_three}
        isPriceLoaded={isPriceLoaded}
      />
      {/* brand slider 1 */}
      {props?.data?.sliders?.length > 0 && (
        <BrandSlider sliders={props?.data?.sliders} />
      )}

      {/* Exterior Card*/}
      {props?.data?.exterior_degree_view && (
        <Exterior360
          longDesc={props?.data?.exterior_degree_view?.title}
          shortDesc={props?.data?.exterior_degree_view?.desc}
          extTitle={props?.data?.exterior_degree_view?.highlights}
          buttonText={props?.data?.exterior_degree_view?.cta_text}
          imgUrl={props?.data?.exterior_degree_view?.image}
          html={props?.data?.exterior_degree_view?.html}
          buttonHref={props?.data?.exterior_degree_view?.cta_link}
          imgSrc={
            mobile
              ? props?.data?.exterior_degree_view?.image_mobile
              : props?.data?.exterior_degree_view?.image_desktop
          }
          colorsArr={colorsArr}
          exteriorViewData={props?.data?.exterior_degree_view}
          parallaxImages={s3ImagesExterior}
          imgArrLength={exteriorImgArrLength}
          configuratorData={props?.data?.configuratorData}
          variantsData = {props?.data?.variants}
        />
      )}

      {/* Interior Card */}

      {props?.data?.degree_view && (
        <Interior360
          buttonHref={props?.data?.degree_view?.cta_link}
          buttonText={props?.data?.degree_view?.cta_text}
          shortDesc={props?.data?.degree_view?.desc}
          extTitle={props?.data?.degree_view?.highlights}
          html={props?.data?.degree_view?.html}
          longDesc={props?.data?.degree_view?.title}
          imgSrc={
            mobile
              ? props?.data?.degree_view?.image_mobile
              : props?.data?.degree_view?.image_desktop
          }
          interiorImageSrc={interiorImageSrc}
          interiorViewData={props?.data?.degree_view}
          parallaxImages={s3ImagesInterior}
          imgArrLength={interiorImgArrLength}
          configuratorData={props?.data?.configuratorData}
        />
      )}

      {/* Card1 Configure - Safety*/}

      {props?.data?.configure?.length > 0 && (
        <BrandCard
          data={props?.data?.configure}
          bookMarkId={"safety"}
          cardRightPadding="md:pr-[55px] lg:pr-[55px] xl:pr-[55px]"
          imageWidth={1288}
          imageHeight={956}
          imageWidthMobile={768}
          imageHeightMobile={564}
          disabled={props?.data?.configure?.length < 2}
        />
      )}

      {/* Card2 Performance*/}
      {props?.data?.performance?.length > 0 && (
        <BrandCard
          data={props?.data?.performance}
          bookMarkId={"performance"}
          classname={"reverseOrder"}
          imageWidth={1288}
          imageHeight={956}
          imageWidthMobile={768}
          imageHeightMobile={564}
          disabled={props?.data?.performance?.length < 2}
        />
      )}

      {/* Card3 - Comfortable Equipment */}

      {props?.data?.comfortable_equipment?.length > 0 && (
        <BrandCard
          data={props?.data?.comfortable_equipment}
          bookMarkId={"comfortable_equipment"}
          cardRightPadding="md:pr-[55px] lg:pr-[55px] xl:pr-[55px]"
          imageWidth={1288}
          imageHeight={956}
          imageWidthMobile={768}
          imageHeightMobile={564}
          disabled={props?.data?.comfortable_equipment?.length < 2}
        />
      )}

      {/* Card4 - See Details*/}
      {props?.data?.see_details && (
        <BrandCard
          Id={
            "ModelDetails" +
            props?.data?.see_details?.title?.replace(/\s+/g, "") // .replace(/\s+/g, "") is used to remove white spaces from the id
          }
          data={[props?.data?.see_details]}
          swipeDisable
          bookMarkId={"see_details"}
          cardContentPadding="md:pr-[60px] lg:pr-[60px] xl:pr-[60px]"
          classname={"fullwidth__card"}
          imageWidth={1920}
          imageHeight={827}
          imageWidthMobile={768}
          imageHeightMobile={564}
          disabled={[props?.data?.see_details]?.length < 2}
        />
      )}

      {/* compare section - Pricing*/}
      {props?.data?.variants?.length > 0 && (
        <CompareBoard
          menuId={props?.data?.menu_id}
          bookMarkId={"pricing"}
          data={props?.data?.variants?.sort(
            (a, b) => a.order_index - b.order_index
          )}
          pageUrl={props?.data?.page_url}
          propulsion={props?.data?.variant_propulsion}
          sortedFeatures={props?.data?.sortedFeatures}
          sortedPerformance= {props?.data?.sortedPerformance}
          data2={props?.data?.images}
          modelcode={props?.data?.model_code || ""}
          modelName={props?.data?.model_name}
          variantCmpfirstPrice={props?.data?.variant_cmp_price_one}
          variantCmpsecondPrice={props?.data?.variant_cmp_price_two}
          variantCmpthirdPrice={props?.data?.variant_cmp_price_three}
          variantCmpfirstPriceText={props?.data?.variant_cmp_pricetext_one}
          variantCmpsecondPriceText={props?.data?.variant_cmp_pricetext_two}
          variantCmpthirdPriceText={props?.data?.variant_cmp_pricetext_three}
          additionalInformationOfModel={props?.data?.additionalInformation}
        />
      )}

      <div className="container-fluid">
        <div className="container-fluid">
          <div className="container">
            <h2
              className="mt-14 text-primary-blue mb-[50px]"
              style={{
                fontSize: "30px",
                lineHeight: "37px",
                letterSpacing: ".02em",
              }}
            >
              {Constants.cars.EXPERIENCE} {props?.data?.model_name}{" "}
              {Constants.cars.TODAY}
            </h2>

            {props?.data?.video?.length > 0 && (
              <div className="brand-page__topic-slider">
                <TopicSlider
                  data={props.data?.video}
                  column={
                    props?.data?.video?.length >= 4
                      ? 4
                      : props?.data?.video?.length
                  }
                />
              </div>
            )}
            <div className="grid grid-cols-2 mb-10 md:grid-cols-4 lg:grid-cols-4">
              <ExperienceIcon
                Id="ModelFindDealer"
                icon={`${configuration.IMG_STATIC_URL1}/assets/images/brand-pages/experience-icons/add_location_alt.svg`}
                title={Constants.findDealerPage.FIND_A_DEALER}
                href={ROUTE_ADDRESS}
              />
              <ExperienceIcon
                Id="ModelTestDriveForm"
                icon={`${configuration.IMG_STATIC_URL1}/assets/images/brand-pages/experience-icons/directions_car.svg`}
                title={Constants.expericencIcon.BOOK_A_TEST_DRIVE}
                onClick={() => dispatch(toggleForm(FormName))}
              />
              <ExperienceIcon
                Id="ModelBrochure"
                icon={`${configuration.IMG_STATIC_URL1}/assets/images/brand-pages/experience-icons/chevron.svg`}
                title={Constants.expericencIcon.DOWNLOAD_BROCHURE}
                onClick={() => dispatch(toggleForm(brochure))}
              />
                             {configuration?.COUNTRY_CODE == "HUN" ?
                             <ExperienceIcon
                             Id="ModelFinanceCalculator"
                             icon={`${configuration.IMG_STATIC_URL1}/assets/images/floatbar/inquiry.svg`}
                             title={Constants.expericencIcon.FINANCE_CALCULATOR}
                             onClick={() => dispatch(toggleForm(Get_a_Quote))}
                           />
               :
              <ExperienceIcon
                Id="ModelFinanceCalculator"
                icon={`${configuration.IMG_STATIC_URL1}/assets/images/floatbar/vietnamese-dong.svg`}
                title={Constants.expericencIcon.FINANCE_CALCULATOR}
                // onClick={() => dispatch(toggleForm(formNames.CALC_PAYMENT))}
                href={
                  configuration?.COUNTRY_CODE != "MEX"
                    ? `${
                        LobValue === "1"
                          ? "/calc-payment?model=" + props?.data?.page_url
                          : LobValue === "2"
                          ? "/calc-payment-2w?model=" + props?.data?.page_url
                          : "/calc-payment-marine?model=" +
                            props?.data?.page_url
                      }`
                    : `/emi-calculator?modelname=${props?.data?.model_name}&modelcode=${props?.data?.model_code}`
                }
              />}
            </div>
          </div>
        </div>

        <TestimonialSliderContainer pageType = {props?.data?.model_code}/>
        {recentModelData &&
        recentModelData?.page_url !== props?.data?.page_url ? (
          <div className="my-14 container-fluid">
            <div className="container">
              <h2
                className="mb-10 text-primary-blue "
                style={{
                  fontSize: "30px",
                  lineHeight: "37px",
                  letterSpacing: ".02em",
                }}
              >
                {Constants.cars.RECENTLY_VIEWED}
              </h2>
              <div className="three-grid-sections ">
                <Carousel
                  responsive={responsive}
                  autoPlay={false}
                  removeArrowOnDeviceType={["desktop", "tablet", "mobile"]}
                  partialVisible={true}
                  className="grid grid-cols-2 gap-6 md:grid-cols-4"
                >
                  <div className="my-3 mr-[2.5rem] ">
                    <HomeSuzukiCard
                      modelCode={recentModelData?.model_code}
                      cardClassName={""}
                      imgSrc={ recentModelData?.images?.desk_small? `${configuration.IMG_URL}${recentModelData?.images?.desk_small}`: "" }
                      alt_text={recentModelData?.images?.desk_small_alt}
                      cardTitle={recentModelData?.model_name}
                      cardItemPrice={recentModelData?.retail_price}
                      itemFuelType={recentModelData?.fuel_type?.toUpperCase()}
                      itemSeater={recentModelData?.vehicle_type}
                      cardLink={recentModelData?.page_url}
                      borderProp="rounded-[0.375rem]"
                    />
                  </div>
                </Carousel>
              </div>
            </div>
          </div>
        ) : (
          props?.data?.car_product?.length > 0 && (
            <div className="my-14 container-fluid">
              <div className="container">
                <h2
                  className="mb-10 text-primary-blue "
                  style={{
                    fontSize: "30px",
                    lineHeight: "37px",
                    letterSpacing: ".02em",
                  }}
                >
                  {Constants.cars.WE_THINK_YOU}
                </h2>
                <div className="three-grid-sections ">
                  <Carousel
                    responsive={responsive}
                    autoPlay={false}
                    removeArrowOnDeviceType={["desktop", "tablet", "mobile"]}
                    partialVisible={true}
                    className="grid grid-cols-2 gap-6 md:grid-cols-4"
                  >
                    {props?.data?.car_product?.map((item, i) => (
                      <div className="my-3 mr-[2.5rem]" key={i}>
                        <HomeSuzukiCard
                          key={i}
                          Id={"Model" + item?.model_code?.replace(/\s+/g, "")} // .replace(/\s+/g, "") is used to remove white spaces from the id
                          modelCode={item?.model_code}
                          cardClassName={""}
                          imgSrc={ item?.images?.desk_small? `${configuration.IMG_URL}${item?.images?.desk_small}` : "" }
                          alt_text={mobile ? item?.images?.mob_small_alt : item?.images?.desk_small_alt}
                          cardTitle={item?.model_name}
                          cardItemPrice={item?.retail_price}
                          itemFuelType={item?.fuel_type?.toUpperCase()}
                          itemSeater={item?.vehicle_type}
                          cardLink={item?.page_url}
                          borderProp="rounded-[0.375rem]"
                          car_page_price_one={item?.car_page_price_one}
                          car_page_price_two={item?.car_page_price_two}
                          car_page_price_three={item?.car_page_price_three}
                          car_page_pricetext_two={item?.car_page_pricetext_two}
                          car_page_pricetext_three={
                            item?.car_page_pricetext_three
                          }
                          additionalInformation={item?.additionalInformation}
                        />
                      </div>
                    ))}
                  </Carousel>
                </div>
              </div>
            </div>
          )
        )}
        {props?.data?.car_topic?.length > 0 && (
          <div className="topics__container" id="topicSection">
            <h2
              className="mb-10 text-primary-blue "
              style={{
                fontSize: "30px",
                lineHeight: "37px",
                letterSpacing: ".02em",
              }}
            >
              {Constants.cars.TOPICS}
            </h2>
            <TopicSlider
              data={props?.data?.car_topic}
              image={props?.data?.car_topic?.isImage ?? true}
              column={
                props?.data?.car_topic?.length >= 4
                  ? 4
                  : props?.data?.car_topic?.length
              }
              cta = {{isCta:true}}
              type="Slider"
            />
          </div>
        )}

        {configuration.MODEL_FAQ == "true" && props?.data?.faqs?.length > 0 && (
          <div id="faq" className="faq container-fluid">
            <div className="container">
              <div className="faq-page-wrapper">
                <div className="faq-slides-wrapper mb-[56px]">
                  <div className={styles.faq_grid_box}>
                    <Accordion
                      newArray={props?.data?.faqs?.map((item) => {
                        return {
                          question: item.ques,
                          answer: item.ans,
                        };
                      })}
                      heads={custServices.heads}
                      selectText={custServices.selectText}
                      openText={custServices.openText}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
